import useLocalStorage from 'hooks/useLocalStorage';
import { MdmTableName, TableOptions } from '../utils/types';
import useProjectContext from './useProjectContext';
import useUserTableDetails from './useUserTableDetails';
import { initialFilter } from '../utils/const';

function useTableFilter(
  tableName: MdmTableName,
  options: Pick<TableOptions, "sortField" | "reqSortField" | "sortOrder">
) {
  const { userSettings, projectId } = useProjectContext();
  const tableDetails = useUserTableDetails(userSettings, tableName);
  const [tableFilter, setTableFilter] = useLocalStorage<TableOptions>(`${projectId}-${tableName}`, {
    ...initialFilter,
    rows: tableDetails?.rows || 10,
    ...options,
  });
  
  return [tableFilter, setTableFilter] as const;
}

export default useTableFilter;